import React from "react";
import { Link } from "react-router-dom";
import { copyTemplate } from "../../../services/Admin/templateService";
import style from "./template.css"
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import CopyAllIcon from "@mui/icons-material/CopyAll";

const Template = ({ templatesList, search, searchTemplate }) => {
  return (
    <div className="row">
      <h1 className="form-heading" style={{ color: "#4A1D75" }}>
        Templates
      </h1>
      {/* <div className="templateHeader"> */}
      {/* <div class="input-group row col-12   mb-2 "> */}
      {/* <div class="input-group-prepend"> */}
      {/* <div class="input-group-text" style={{ borderRadius: "40px" }}>
            <img
              src="https://img.icons8.com/search"
              style={{ maxWidth: "30px" }}
            />
            <input
              type="text"
              value={search}
              onChange={(text) => searchTemplate(text)}
              class="form-control"
              placeholder="Search Curriculum/Subject/Template Name"
              style={{ borderRadius: "40px" }}
            />
          </div> */}
      {/* </div> */}
      {/* </div>
        <div style={{ borderRadius: "40px" }}>
          <Link
            to={`/admin/add-template`}
            className="btn btn-sm add-btn"
            style={{
              borderRadius: "40px",
              backgroundColor: "#4A1D75",
              border: "2px solid #4A1D75",
              width: "150px",
              textAlign: "center",
              padding: "15px",
            }}
          >
            Add Template
          </Link>
        </div>
      </div> */}
      <div className="templateHeader">
        <div class="search">
          <span class="fa fa-search"></span>
          <input
            // placeholder="Search Curriculum"
            style={{ borderRadius: "30px" }}
            type="text"
            value={search}
            onChange={(text) => searchTemplate(text)}
            // class="form-control"
            placeholder="Search"
          />
        </div>
        <div>
          <Link
            to={`/admin/add-template`}
            className="btn btn-sm add-btn"
            style={{
              borderRadius: "40px",
              backgroundColor: "#4A1D75",
              border: "2px solid #4A1D75",
              width: "140px",
              textAlign: "center",
              padding: "6px",
              color: "white",
              height: "auto",
            }}
          >
            Add Template
          </Link>
        </div>
      </div>
      <div className="col-md-12 table_container">
        {/* <div className="card"> */}
          <div className="card-body">
            <table className="table table">
              <thead>
                <tr>
                  <th scope="col" style={{  }}>
                    Template ID
                  </th>
                  <th scope="col" style={{}}>
                    Template Name
                  </th>
                  <th scope="col" style={{  }}>
                    Curriculum
                  </th>
                  <th scope="col" style={{  }}>
                    Subject
                  </th>
                  <th scope="col" style={{  }}>
                    Template Type
                  </th>
                  <th scope="col" style={{ }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {templatesList &&
                  templatesList.length > 0 &&
                  templatesList.map((q) => {
                    return (
                      <tr key={q._id}>
                        <td>{q.templateID}</td>
                        <td>{q.templateName} </td>

                        <td>{q.curriculum}</td>
                        <td>{q.subject}</td>
                        <td>{q.templateType}</td>
                        <td className="w-25">
                          <Link to={`/admin/edit-template/${q.templateID}`}>
                            <button
                              className="btn btn-sm mr-2"
                              style={{ backgroundColor: " #FFE7A8" }}
                            >
                              <span style={{ color: "#EAB731" }}>
                                <BorderColorIcon
                                  style={{ color: "#EAB731", fontSize: "13px" }}
                                />
                                <b style={{ fontSize: "11px" }}> Edit</b>
                              </span>
                            </button>
                          </Link>
                          <Link to={`/admin/view-template/${q.templateID}`}>
                            <button
                              className="btn btn-sm ml-2"
                              style={{
                                backgroundColor: "#DEF2E9",
                                marginLeft: "10px",
                              }}
                            >
                              <span style={{ color: "#49AF48" }}>
                                <RemoveRedEyeIcon
                                  style={{ color: "#49AF48", fontSize: "13px" }}
                                />
                                <b style={{ fontSize: "11px" }}>View</b>
                              </span>
                            </button>
                          </Link>
                          {q.templateName[q.templateName.length - 1] ===
                          ")" ? null : (
                            <button
                              onClick={() => {
                                async function test() {
                                  await copyTemplate(q._id);
                                  window.location.reload();
                                }
                                test();
                              }}
                              className="btn btn-sm "
                              style={{
                                backgroundColor: " #E0F6F6",
                                // marginTop: "10px",
                                marginLeft: "10px",
                              }}
                            >
                              <span style={{ color: "#1DB9AA" }}>
                                <CopyAllIcon
                                  style={{ color: "#1DB9AA", fontSize: "13px" }}
                                />
                                <b style={{ fontSize: "11px" }}> Copy</b>
                              </span>
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    // </div>
  );
};

export default Template;
